<template>
  <div class="common-layout">
    <keep-alive>
      <Header></Header>
    </keep-alive>
    <keep-alive>
      <Main></Main>
    </keep-alive>
    <keep-alive>
      <Footer></Footer>
    </keep-alive>

    <!-- <el-container>
      <el-header>
        <Header></Header>
      </el-header>
      <el-main>
        <Main></Main>
      </el-main>
      <el-footer>
        <Footer></Footer>
      </el-footer>
    </el-container> -->
  </div>
</template>

<script>
// 引入vue-router
import Header from "./header.vue";
import Footer from "./footer.vue";
import Main from "./MainWrap.vue";
export default {
  components: { Header, Footer, Main },
  setup() {},
};
</script>
